export default __webpack_public_path__ + "static/media/Schedule-Meeting.1ad69315.svg";